import { useState } from "react";
import { ProjectActivityView } from "src/api/generated/erp/db/types/tables/projectActivityView.ts";
import { CenteredTypography } from "src/components/common/CenteredTypography.tsx";
import { SingleSourceTasksView } from "src/components/views/tasks/pages/SingleSourceTasksView.tsx";
import {
	ProjectActivitiesDataGrid,
	ProjectActivitiesDataGridProps,
} from "src/components/views/erp/project/projectActivity/ProjectActivitiesDataGrid.tsx";
import i18n from "i18next";
import { SingleActivityMaterialsDataGrid } from "src/components/views/erp/project/projectActivity/material/SingleActivityMaterialsDataGrid.tsx";
import { CostEventsOfObjectDataGrid } from "src/components/views/erp/common/costEvents/CostEventsOfObjectDataGrid.tsx";
import { AavoMosaic } from "src/components/common/mosaic/AavoMosaic.tsx";
import { useRefreshRef } from "src/utils/useRefreshRef.ts";

export interface ProjectActivitiesContainerViewProps {
	subProjectOrActivityId: ProjectActivitiesDataGridProps["subProjectOrActivityId"];
}

export const ProjectActivitiesContainerView = ({ subProjectOrActivityId }: ProjectActivitiesContainerViewProps) => {
	const [selectedActivity, setSelectedActivity] = useState<ProjectActivityView | undefined>(undefined);

	const selectActivityTypography = <CenteredTypography children={i18n.t("select_an_activity")} />;

	const tasksViewRefreshRef = useRefreshRef();

	return (
		<AavoMosaic
			viewId={"80CEED57FF71A199"}
			layout={{
				type: "column",
				first: {
					type: "panel",
					title: i18n.t("activities"),
					content: (
						<ProjectActivitiesDataGrid
							subProjectOrActivityId={subProjectOrActivityId}
							onSelectionChanged={setSelectedActivity}
							tasksViewRefreshRef={tasksViewRefreshRef}
						/>
					),
				},
				second: {
					type: "tabs",
					items: [
						{
							type: "panel",
							title: i18n.t("tasks"),
							content:
								selectedActivity == null ? selectActivityTypography : (
									<SingleSourceTasksView
										key={selectedActivity.activityId}
										taskSourceRef={{
											sourceType: "PROJECT_ACTIVITY",
											sourceId: selectedActivity.activityId,
										}}
										refreshRef={tasksViewRefreshRef}
									/>
								),
						},
						{
							type: "panel",
							title: i18n.t("materials"),
							content:
								selectedActivity == null ? selectActivityTypography : (
									<SingleActivityMaterialsDataGrid
										key={selectedActivity.activityId}
										activityId={selectedActivity.activityId}
									/>
								),
						},
						selectedActivity?.costEventPriceListId != null && {
							type: "panel",
							title: i18n.t("cost_events"),
							content: (
								<CostEventsOfObjectDataGrid
									key={selectedActivity.activityId}
									objectRef={{
										objectType: "PROJECT_ACTIVITY",
										objectId: selectedActivity.activityId,
									}}
									costEventPriceListId={selectedActivity.costEventPriceListId}
								/>
							),
						},
					],
				},
			}}
		/>
	);
};
